import styled from "styled-components";

export const Content = styled.div`
  .toast{
    background-color: #C33333;
    position: absolute;
    bottom: -50px;
    height: 50px;
    left: 20px;
    min-width: 300px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    color: #fff;
    transition: bottom 0.5s ease;
    border-radius: 10px;

    img{
      width: 22px;
      margin-right: 10px;
    }

    span{
      padding: 0;
      margin: 0;
    }

    
  }
  
  /* Aviso amigavel: contraste #17402A sobre #EAF4EC (~11:1). Mais largo para caber a frase. */
  .toast.info{
    background-color: #EAF4EC;
    color: #17402A;
    border: 1px solid #8CC09B;
    height: auto;
    min-height: 50px;
    max-width: min(520px, calc(100vw - 40px));
    padding: 10px 24px 10px 20px;
    line-height: 140%;
    font-size: 14px;
    bottom: -200px;
    z-index: 1200;
    box-shadow: 0 4px 14px rgba(0,0,0,0.18);
  }

  .active{
    bottom: 20px !important;
  }
`